module.exports = __webpack_public_path__ + "LatoLatin-SemiboldItalic.656cf9170f1e53fc58c7.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.woff2
// module chunks = styles